import React, { useEffect, useMemo, useState } from 'react'
import { SimulatorOfferModel } from '../models/superbit-api-models';
import DropDownIcon from '../components/_DropDownIcon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setOfferId, setLeadId } from './../app-context/policyProduction'
import { mn } from 'date-fns/locale';


interface RenewalDetailsProps {
    offer: SimulatorOfferModel | null;
    
    getAuthorizedToDriveName: any;
emailAddress: string;
leadId: any;
    
}

const RenewalDetails: React.FC<RenewalDetailsProps> = ({
    offer,    
    getAuthorizedToDriveName,
    emailAddress,
    leadId,
    
}) => {
    const dispatch = useDispatch();

    const getNumberOrZero = (int: number | undefined | null) => {
        if (int != null && int != undefined)
            return int;
        return 0;
    }

    
    const openProduction = async () => {

        //set id to state
        if (offer && offer.id) {

            dispatch(setOfferId(offer.id))
            dispatch(setLeadId(leadId))
        }
        // this.props.onProductionClick(this.props.offer);
    }


    if (!offer) {
        return null;
    }

    return (

        <div className="detailsscontent-row flex-centered flex-space-between" style={{width:"100%"}}>

            <div className="cell-price">
                {offer.offerIdentity}
            </div>
            <div className="cell date" style={{ minWidth: 140, width: 140 }}>
                <div className='inner-row'>
                    <span className='title'>
                        ת.יצירה:
                    </span>
                    {" " + moment(offer.createdDate).format('DD-MM-YYYY')}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ת.תחילה:
                    </span>
                    {" " + moment(offer.startDate).format('DD-MM-YYYY')}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ת.סיום:
                    </span>
                    {" " + moment(offer.endDate).format('DD-MM-YYYY')}
                </div>
            </div>
            {/* <div className="cell date">
                {moment(offer.startDate).format('DD-MM-YYYY')}
            </div>
            <div className="cell date">
                {moment(offer.endDate).format('DD-MM-YYYY')}
            </div> */}



            <div className="cell-price" style={{ width: 90 }}>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            גיל צעיר:
                        </span>
                        {" " + offer.driverYoungAge}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            וותק צעיר:
                        </span>
                        {" " + offer.driverYoungSeniority}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                        גיל עיקרי:
                        </span>
                        {" " + offer.driverMainAge}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            וותק עיקרי:
                        </span>
                        {" " + offer.driverMainSeniority}
                    </div>
            </div>
            
            <div className="cell-price">
                {getAuthorizedToDriveName(offer.authorizedToDrive)}
            </div>
            <div className="pass-insurance">
                {offer.vehicle && offer.vehicle.vehicleSubModel ? (
                    <>
                        <div className='inner-row'>
                            <span className='title'>
                                קוד דגם:
                            </span>
                            {" " + offer.vehicle.modelCode ? offer.vehicle.modelCode : ''}
                        </div>
                        <div className='inner-row'>
                            <span className='title'>
                                רישוי:
                            </span><br />
                            {" " + offer.vehicle.licenseNumber ? offer.vehicle.licenseNumber : ''}
                        </div>
                    </>
                ) : ''}

            </div>

            <div className="cell insurance-company" style={{ minWidth: 'fit-content' }}>
                {offer.insuranceCompany != null ? (
                    <div className='inner-row'>{offer.insuranceCompany.name}</div>
                ) : ""}
                <div className='inner-row'>
                    <span className='title'>
                        ענף:
                    </span>
                    {offer.routeId != null ? offer.routeId : 0}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        מסלול:
                    </span> <br />
                    {offer.routeComment} {offer.additionalDetails && offer.additionalDetails.indexOf('coverage10000\':true')!=-1?"10000":""}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        סוג ביטוח:
                    </span> <br />
                    {getAuthorizedToDriveName()}
                </div>
            </div>
            <div className='pass-insurance'>
                <div className='inner-row'>
                    <span className='title'>
                        שנה:
                    </span>
                    {" " + offer.passedTypeOfInsurance1 && offer.passedTypeOfInsurance1 == 2 ? "X" : offer.sueNumber1}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שנתיים:
                    </span>
                    {" " + offer.passedTypeOfInsurance2 && offer.passedTypeOfInsurance2 == 2 ? "X" : offer.sueNumber2}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שלוש שנים:
                    </span>
                    {" " + offer.passedTypeOfInsurance3 && offer.passedTypeOfInsurance3 == 2 ? "X" : offer.sueNumber3}
                </div>
            </div>
            <div className="pass-insurance">
                <div className='inner-row'>
                    <span className='title'>
                        מיקוד:
                    </span>
                    {" " + offer.postalCode ? offer.postalCode : ''}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        תביעות גוף:
                    </span>
                    {" " + offer.bodyClaimsAmount ? offer.bodyClaimsAmount : ''}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שלילות:
                    </span>
                    {" " + offer.revocationsAmount ? offer.revocationsAmount : ''}
                </div>
            </div>

            <div className="pass-insurance">
                <div className='inner-row'>
                    <span className='title'>
                        כינון.א:
                    </span>
                    {offer.autodirection ? 'כן' : 'לא'}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                         נוהג בשבת:
                    </span>
                    {offer.driveInShabbat ? 'כן' : 'לא'}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ח.ת.י:
                    </span>
                    {offer.newForOld ? 'כן' : 'לא'}
                </div>
            </div>
            {/* <div className="cell">
                {offer.routeId!=null? offer.routeId:0}
            </div>
            <div className="cell wide">
            {offer.routeComment}
            </div>
            <div className="cell">
                {this.state.insuranceLabel}
            </div> */}
            <div className="cell-price">
                {offer.comments && offer.comments.length > 0 ? offer.comments[0].slice(0, 10) : ""}
            </div>
            
            
            
        </div>
    )
}

export default RenewalDetails